import 'core-js/features/array/find';
import 'core-js/features/array/includes';
import 'core-js/features/object/assign';
import 'core-js/features/promise/finally';
import Vue from 'vue';
import App from './App.vue'; // eslint-disable-line sort-imports
import VueResource from 'vue-resource';
import router from './router';
import store from './store';

Vue.use(VueResource);

Vue.prototype.$rvc = {
    locApiEndpoint: document.getElementById('app').getAttribute('data-loc-api-endpoint')
};

// eslint-disable-next-line no-new
new Vue({
    el: '#app',
    router,
    store,
    render: h=>h(App)
});